export default (storeState, {payload}) => {
    let newState = Object.assign({}, storeState);
    newState.shops = payload;

    return newState;
};
